import { render } from "./VideoRoom.vue?vue&type=template&id=55a0fc7e&scoped=true"
import script from "./VideoRoom.vue?vue&type=script&lang=js"
export * from "./VideoRoom.vue?vue&type=script&lang=js"

import "./VideoRoom.vue?vue&type=style&index=0&id=55a0fc7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a0fc7e"]])

export default __exports__